import { Box } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import useTrashablePromises from "hooks/useTrashablePromises";
import { useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { SaveContentRequest, SaveResponse } from "services/KnowfullyAdminClient";
import contextStore from "stores/contextStore";
import translateError from "utils/translateError";
import { ContentBlockForm } from "./ContentBlockForm";

export function ContentBlockCreateForm() {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { contentService, contentBlocksUrl } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { organizationId } = contextStore.useState();

  const onCancel = () => {
    navigate(contentBlocksUrl());
  };

  const title = t({ id: "createContentBlock" });
  useTitle(title);

  const onSubmit = async (values: SaveContentRequest) => {
    try {
      const created: SaveResponse = await registerPromise(
        contentService.saveContentItem(
          SaveContentRequest.fromJS({
            ...values,
            organizationId: organizationId,
          })
        )
      );

      queryClient.invalidateQueries(["contentService.getContentBlocks"]);

      navigate(contentBlocksUrl());

      return created;
    } catch (err: any) {
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={contentBlocksUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <ContentBlockForm
        onSubmit={onSubmit}
        submitLabel={title}
        onCancel={onCancel}
      />
    </>
  );
}
